import React from "react";
import { ChevronLeft } from "lucide-react";

import { Button } from "@/components/ui/button";

import { cn } from "@/lib/utils";

function CourseSwiperNav({ swiper, prevNavRef, nextNavRef, className }) {
  React.useEffect(() => {
    if (swiper && swiper.params) {
      swiper.params.navigation.prevEl = prevNavRef.current;
      swiper.params.navigation.nextEl = nextNavRef.current;
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [swiper, prevNavRef, nextNavRef]);

  return (
    <div className={cn("flex gap-x-4", className)}>
      <Button
        ref={prevNavRef}
        variant="outline"
        size="icon"
        className={cn(
          "bg-primary-bg border-primary-bg-strong rounded-full transition-colors duration-300",
          "disabled:bg-grayscale-weak disabled:border-primary-weak disabled:[&>svg]:text-primary-weak"
        )}
      >
        <ChevronLeft className="size-5" />
      </Button>

      <Button
        ref={nextNavRef}
        variant="outline"
        size="icon"
        className={cn(
          "bg-primary-bg border-primary-bg-strong rounded-full transition-colors duration-300",
          "disabled:bg-grayscale-weak disabled:border-primary-weak disabled:[&>svg]:text-primary-weak"
        )}
      >
        <ChevronLeft className="size-5 rotate-180" />
      </Button>
    </div>
  );
}

export default CourseSwiperNav;
